import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { TablePagination, Typography } from "@material-ui/core";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import MoldalModules from "./modalModules";
import {
  getAllRoles,
  getModules,
  getFunctionality,
  getAllRoleById,
  updateRoleModules,
} from "../../actions/role-actions";
import { useStateValue } from "../../context/store";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import IconButton from "../../utils/form/IconButton";
import Search from "../../images/icons/search.svg";
import { headers } from "./dataModel";
import TableRoles from "./tableRoles";
import SearchRoles from "./searchRol";
import CreateRol from "./createRol";
import { styles } from "../styles";
import PropTypes from "prop-types";
import Utils from "../../utils/utils";
import _ from "lodash";
import { permissionsConstans } from "../../constansPermissions";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const Index = () => {
  const classes = styles();
  const [allRoles, setAllRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState({});
  const [allModules, setAllModules] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [localSelectedRole, SetLocalSelectedRole] = useState([]);
  const [localSelectedRoleBase, SetLocalSelectedRoleBase] = useState([]);
  const [permissionsRoles, setPermissionsRoles] = useState([]);
  const [resultSearch, setResultSearch] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [selectedAllRoles, setSelectedAllRoles] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [{}, dispatch] = useStateValue();
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const rows = resultSearch;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const callGetAllRoles = async () => {
    const response = await getAllRoles();

    setAllRoles(response.data.roleList);
    setResultSearch(response.data.roleList);
  };

  const callGetAllRoleById = async (roleId) => {
    const response = await getAllRoleById(roleId);
    setSelectedRole(response?.data);
    return response?.data;
  };
  const callGetAllModules = async () => {
    const response = await getModules();
    setAllModules(
      _.sortBy(response.data.moduleResponseList, [
        function (o) {
          return o.priority;
        },
      ])
    );
  };

  const validationPermissionSearch = () => {
    if (
      permissionsRoles?.functionalities?.some(
        (x) => x === permissionsConstans.ROL_CONSULTAR
      )
    ) {
      return <SearchRoles dataFilter={dataFilter} currentData={allRoles} />;
    }
  };
  const validationPermissionCreate = () => {
    if (
      permissionsRoles?.functionalities?.some(
        (x) => x === permissionsConstans.ROL_CREAR
      )
    ) {
      return (
        <React.Fragment>
          <Typography
            className={classes.titleCreate}
            style={{ marginTop: "40px" }}
          >
            Registro roles nuevos
          </Typography>
          <CreateRol
            setMessage={setMessage}
            message={message}
            resetData={resetData}
          />
        </React.Fragment>
      );
    }
  };

  useEffect(() => {
    callGetAllRoles();
    const responsePersmissions = Utils.validationPermissions("ROL");
    setPermissionsRoles(responsePersmissions);
    callGetAllModules();

    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Seguridad    |     Roles",
      breadCrumbSubText: "Roles",
      index: 8,
    });
    setPage(0);
  }, [!refresh]);

  const resetData = () => setRefresh(!refresh);
  const openModalEvent = async (data = {}, open = false) => {
    setOpenModal(open);
    const rolFull = await callGetAllRoleById(data?.id);

    let permitionsRol = rolFull?.moduleList?.map((x) => {
      const functionalities = [...x?.functionalityList];
      return { code: x?.code, functionalityList: functionalities };
    });

    const validateHv = permitionsRol.some((x) => x.code === "HV");

    if (validateHv) {
      SetLocalSelectedRole(JSON.parse(JSON.stringify(permitionsRol)));
      SetLocalSelectedRoleBase(JSON.parse(JSON.stringify(permitionsRol)));
    } else {
      const moduleHv = allModules.find((x) => x.code === "HV");

      const addHvToPermissions = permitionsRol.push({
        code: moduleHv?.code,
        functionalityList: moduleHv.functionalityList,
      });

      SetLocalSelectedRole(JSON.parse(JSON.stringify(permitionsRol)));
      SetLocalSelectedRoleBase(JSON.parse(JSON.stringify(permitionsRol)));
    }
  };
  const closeModalEvent = () => {
    setOpenModal(false);
  };

  const acceptModalEvent = () => {
    setOpenModal(false);

    setMessage({
      description: "¿Está seguro de actualizar los módulos para este rol?",
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClick(),
      handleClickOut: () => handleClickClose(),
      type: "WARNING",
      open: true,
    });
  };

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
    getAllRoles();
  };

  const handleClick = () => {
    const data = {
      roleId: selectedRole?.id,
      funtionalityIdList: [],
    };
    for (const item of localSelectedRole) {
      for (const subItem of item?.functionalityList) {
        const resultQuery = data?.funtionalityIdList?.find(
          (x) => x?.id === subItem?.id
        );
        if (!resultQuery) data.funtionalityIdList.push(subItem?.id);
      }
    }

    setMessage({ ...message, open: false });
    const create = async () => {
      const response = await updateRoleModules(data);

      if ((response && response.status === 200) || response.status === 201) {
        setMessage({
          description: `Rol actualizado exitosamente`,
          textButtonSubmit: "Aceptar",
          oneButtons: true,
          handleClick: () => handleClickClose(),
          type: "SUCCESS",
          open: true,
        });
      } else {
        setMessage({
          description: response?.data?.detail,
          textButtonSubmit: "Aceptar",
          oneButtons: true,
          handleClick: () => handleClickClose(),
          type: "WARNING",
          open: true,
        });
      }
    };
    create();
  };

  const cancelModalEvent = () => {
    setOpenModal(false);
    SetLocalSelectedRole(localSelectedRoleBase);
  };

  const changeModuleCheckModalEvent = (moduleId, value) => {
    let currentPerm = [...localSelectedRole];
    const indexModule = currentPerm.findIndex((x) => x?.code === moduleId);
    if (!value && indexModule > -1) {
      currentPerm.splice(indexModule, 1);
      SetLocalSelectedRole(currentPerm);
    } else {
      let record = allModules?.find((x) => x?.code === moduleId);
      currentPerm.push({
        code: record?.code,
        functionalityList: record?.functionalityList,
      });
      SetLocalSelectedRole(currentPerm);
    }
  };

  const changeFunctionalityCheckModalEvent = (functId, value, moduleId) => {
    const resultModule = localSelectedRole.find((x) => x?.code === moduleId);
    if (resultModule) {
      let selectedRoles = JSON.parse(JSON.stringify(localSelectedRole));

      if (!value) {
        const module = JSON.parse(JSON.stringify(resultModule));
        const indexModule = module?.functionalityList?.findIndex(
          (x) => x?.id === functId
        );
        if (indexModule > -1) {
          module.functionalityList.splice(indexModule, 1);
          let moduleIndexToUpdated = selectedRoles?.findIndex(
            (x) => x?.code === moduleId
          );
          selectedRoles[moduleIndexToUpdated] = { ...module };
          if (
            selectedRoles[moduleIndexToUpdated]?.functionalityList?.length === 0
          ) {
            const indexModuleEmpty = selectedRoles?.findIndex(
              (x) => x?.code === moduleId
            );
            selectedRoles.splice(indexModuleEmpty, 1);
          }
          SetLocalSelectedRole(selectedRoles);
        }
      } else {
        const module = JSON.parse(JSON.stringify(resultModule));
        let record = { ...allModules?.find((x) => x?.code === moduleId) };
        let recordFunc = {
          ...record?.functionalityList?.find((d) => d?.id === functId),
        };
        module.functionalityList.push({ ...recordFunc });
        let moduleIndexToUpdated = selectedRoles?.findIndex(
          (x) => x?.code === moduleId
        );
        selectedRoles[moduleIndexToUpdated] = { ...module };
        SetLocalSelectedRole(selectedRoles);
      }
    } else {
      let record = { ...allModules?.find((x) => x?.code === moduleId) };
      let funcList = {
        ...record?.functionalityList?.find((x) => x?.id === functId),
      };
      record["functionalityList"] = [{ ...funcList }];
      let selectedRoles = [...localSelectedRole];
      selectedRoles.push(record);
      SetLocalSelectedRole(selectedRoles);
    }
  };

  const dataFilter = (x) => {
    setPage(0);
    setResultSearch(x);
  };

  const sendRoles = () => {
    setSelectedAllRoles(!selectedAllRoles);
    LogicalSelectedPermissions();
  };
  const LogicalSelectedPermissions = () => {
    if (selectedAllRoles) {
      let permitionsRol = allModules?.map((x) => {
        const functionalities = [...x?.functionalityList];
        return { code: x?.code, functionalityList: functionalities };
      });
      SetLocalSelectedRole(JSON.parse(JSON.stringify(permitionsRol)));
      SetLocalSelectedRoleBase(JSON.parse(JSON.stringify(permitionsRol)));
    } else {
      SetLocalSelectedRole(JSON.parse(JSON.stringify([])));
      SetLocalSelectedRoleBase(JSON.parse(JSON.stringify([])));
    }
  };

  return (
    <div style={{ marginTop: "40px" }}>
      {validationPermissionCreate()}
      {validationPermissionSearch()}

      <Typography className={classes.titleCreate}>Información roles</Typography>
      {(rowsPerPage > 0
        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : rows
      ).map((row, index) => (
        <TableRoles
          permissionsRoles={permissionsRoles}
          actionOpen={openModalEvent}
          data={row}
          headers={headers}
          openModuleEvent={openModalEvent}
          resetData={resetData}
        />
      ))}

      {rows.length !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          labelRowsPerPage="Registros por página"
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      ) : (
        <div>
          <div className={classes.messageSearch}>
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}

      <ModalConfirm
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={message.open}
      />
      <MoldalModules
        selectedAllRoles={sendRoles}
        acceptModalEvent={acceptModalEvent}
        cancelModalEvent={cancelModalEvent}
        openModalEvent={openModalEvent}
        closeModalEvent={closeModalEvent}
        openModal={openModal}
        modules={allModules}
        selectedRole={selectedRole}
        localSelectedRole={localSelectedRole}
        changeModuleCheckModalEvent={changeModuleCheckModalEvent}
        changeFunctionalityCheckModalEvent={changeFunctionalityCheckModalEvent}
      />
    </div>
  );
};

export default Index;
